import React from 'react';
import './UserTable.css';

interface User {
  id: string;
  name: string;
  email: string;
  role: string;
  status: 'ACTIVE' | 'INACTIVE' | 'BLOCKED' | 'PENDING';
  lastLogin: string;
  avatar?: string;
}

interface UserTableProps {
  users: User[];
  selectedUsers: string[];
  onSelectUser: (userId: string) => void;
  onSelectAll: () => void;
}

const UserTable: React.FC<UserTableProps> = ({
  users,
  selectedUsers,
  onSelectUser,
  onSelectAll,
}) => {
  const allSelected = selectedUsers.length === users.length && users.length > 0;

  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map(n => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const getStatusClass = (status: string) => {
    return status.toLowerCase();
  };

  return (
    <div className="user-table-container">
      <table className="user-table">
        <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                checked={allSelected}
                onChange={onSelectAll}
                className="table-checkbox"
              />
            </th>
            <th>User ID</th>
            <th>Name</th>
            <th>Email</th>
            <th>Roles</th>
            <th>Status</th>
            <th>Last Login</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user.id}>
              <td>
                <input
                  type="checkbox"
                  checked={selectedUsers.includes(user.id)}
                  onChange={() => onSelectUser(user.id)}
                  className="table-checkbox"
                />
              </td>
              <td className="user-id">{user.id}</td>
              <td>
                <div className="user-name-cell">
                  <div className="user-avatar">{getInitials(user.name)}</div>
                  <span>{user.name}</span>
                </div>
              </td>
              <td className="user-email">{user.email}</td>
              <td>
                <span className="user-role">{user.role}</span>
              </td>
              <td>
                <span className={`user-status status-${getStatusClass(user.status)}`}>
                  {user.status}
                </span>
              </td>
              <td className="user-last-login">{user.lastLogin}</td>
              <td>
                <button className="user-actions-btn">⋯</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UserTable;

